<template>
  <!-- 新日账单明细 -->
  <div class="home-page-container">
    <!-- search 查询 -->
    <el-card shadow="never">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="search"
        @reset="reset()"
        :loading="tableLoading">
        <template slot="collectionOrder">
          <el-date-picker v-model="searchBar.msgDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </template>
        <template slot="handler">
          <el-button size="mini" @click="readAllApi">全部已读</el-button>
        </template>
      </mer-search>
    </el-card>
    <!-- table 表格 -->
    <el-card shadow="never">
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange"
        :hasIndex="false">
        <template slot="handler" slot-scope="{row}">
          <el-button-group>
            <el-button size="mini" @click="goDetail(row)">查看</el-button>
          </el-button-group>
        </template>
      </mer-table>
    </el-card>
    <!-- 增长计划活动详情 -->
    <el-dialog
      :title="getActivityTitle"
      :visible.sync="activeDialogVisible"
      width="60%"
      @close="activeDialogVisible = false"
      center>
      <div class="dialog_content">
        <!-- <div class="dialog_row">
          <span class="title">活动油站：</span>
          <span>{{  }}</span>
        </div> -->
        <div class="dialog_row" v-for="item in activeTableData" :key="item.gasId">
          <div>
            <span v-if="!userInfo.company" class="title">活动油站：</span>
            <span>{{ item.gasName }}</span>
          </div>
          <div v-if="!userInfo.company" class="title" style="margin-top: 20px;">活动内容：</div>
          <el-table
            :data="item.gasConfigList"
            border>
            <el-table-column prop="spuName" label="油品" align="center"></el-table-column>
            <el-table-column prop="oilName" label="油号" align="center"></el-table-column>
            <el-table-column prop="discountTypeDesc" label="优惠类型" align="center"></el-table-column>
            <el-table-column prop="discountRatio" label="营销优惠" align="center">
              <template slot-scope="{row}">
                {{ `${row.discountRatio}${row.discountType === 1 ? '%' : '元'}` }}
              </template>
            </el-table-column>
            <el-table-column prop="statusDesc" label="状态" align="center"></el-table-column>
            <el-table-column v-if="activityType === 12" prop="startTime" label="活动开始时间" align="center"></el-table-column>
            <el-table-column v-if="activityType === 12" prop="expireTime" label="活动结束时间" align="center"></el-table-column>
            <el-table-column prop="effectiveTime" label="生效时间" align="center"></el-table-column>
            <el-table-column prop="endTime" label="失效时间" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="dialog_row">
          <span class="title">操作日志：</span>
          <el-table
            :data="activeLogData"
            border>
            <el-table-column prop="gasName" label="油站名称" align="center"></el-table-column>
            <el-table-column prop="dimensionDesc" label="操作维度" align="center"></el-table-column>
            <el-table-column prop="userName" label="操作账号" align="center"></el-table-column>
            <el-table-column prop="createTime" label="操作时间" align="center"></el-table-column>
            <el-table-column prop="ip" label="操作设备IP" align="center"></el-table-column>
            <el-table-column prop="content" label="操作内容" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 通道费告知函确认弹窗（待确认） -->
    <ChannelFeeNotice ref="channelFeePop" v-if="showChannelFeeNotice" @confirm-success="onChannelFeeConfirmed" @close="showChannelFeeNotice = false"></ChannelFeeNotice>
    <!-- 通道费告知函操作记录弹窗（已确认） -->
    <ChannelFeeRecord ref="channelFeeRecord"></ChannelFeeRecord>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import dailyBillMix from '@/views/finance/mixins/dailyBill';
import { getLetterListWithPge, readAll, getMsgTypeList, getActivityDetail } from '@/api/messageManage'
import { queryChannelFeeConfirmHistory } from '@/api/login'
import ChannelFeeNotice from '@/views/layout/components/dialog/channelFeeNotice.vue'
import ChannelFeeRecord from '@/views/layout/components/dialog/channelFeeRecord.vue'
import store from '@/store'
import { mapState } from 'vuex'

  // 查询表单配置
let formConfig = [
  { label: '消息标题', type: 'input', modelName: 'msgTitle', placeholder: '', maxlength: 100 },
  { label: '收取日期', type:'slot', slotName: 'collectionOrder'},
  { label: '消息状态', type: 'select', modelName: 'status', placeholder: '全部', selectOptions: [{ label: '未读', value: 0 }, { label: '已读', value: 1 }], define: true, selectLabel: 'label', selectValue: 'value' },
  { label: '消息类型', type: 'select', modelName: 'msgType', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'label', selectValue: 'value' }
]
// 表格参数配置
let tableConfig = [
  { label: '消息标题', prop: 'msgTitle', width: 190 },
  { label: '消息类型', prop: 'msgTypeCode', width: 200 },
  { label: '收取日期', prop: 'msgDate', width: 150 },
  { label: '消息状态', prop: 'status', width: 136 },
  { label: '操作', slot: 'handler', fixed: 'right', width: 150 }
]

export default {
  mixins:[ listPage, queryMix, dailyBillMix ],
  components: { ChannelFeeNotice, ChannelFeeRecord },
  data(){
    return{
      tradeTime:'',
      formConfig,
      tableConfig,
      searchBar: {
        msgDate: '',
        status: ''
      },
      options:{
        status:[]
      },
      activeDialogVisible: false,
      activeTableData: [],
      activeLogData: [],
      activityType: 9, // 活动类型，9-增长计划，10-聚宝计划
      showChannelFeeNotice: false, // 通道费告知函确认弹窗
    }
  },
  //  created(){
  //   if(this.saveInfo) this.searchBar.status = 0
  //   this.initPage()
  // },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 从工作台页面进来，状态是未读，否则全部，刷新也是全部状态
      // if(from.name === 'workPlatform' && vm.saveInfo) {
      if(from.name === 'businessAnalysis' && vm.saveInfo) {
        vm.searchBar.status = 0
      }
      vm.initPage()
      vm.$track.pageViewEvent('消息管理', '1628492814')
    })
  },
  computed: {
    ...mapState({
      saveInfo: state => state.saveCustomer.saveInfo,
      userInfo: state => state.user.userInfo
    }),
    getActivityTitle () {
      // :title="`${activityType == 9 ? '增长' : '聚宝'}计划活动详情`"
      const activityInfo = {
        9: '增长计划',
        10: '点金计划',
        12: '锁客宝'
      }
      let name = activityInfo[this.activityType]
      return `${name}活动详情`
    }
  },
  methods:{
    initPage () {
      this.getAllQueryProps()
      this.initList(getLetterListWithPge)
    },
    getAllQueryProps(){
      this.getQueryStatus()
      //获取油站
      this.getAllGasStations()
    },
    async goDetail (row) {
      // 通道费告知函（msgType 11）：取本行 pushContent 中的 id，与 noticeContents 各项 id 匹配，
      // 用匹配项的 status 判断——WAIT_CONFIRM 弹确认弹窗，否则弹操作记录
      if (row.msgType === 11) {
        const { code, result } = await queryChannelFeeConfirmHistory({ msgId: row.id })
        if (code !== 200 || !result) return
        // 查看后刷新消息列表（同步已读等状态）
        this.initList(getLetterListWithPge)
        const noticeContents = result.noticeContents || []
        // pushContent 为 JSON 字符串，解析失败则降级为不匹配
        let pushId = null
        try {
          pushId = JSON.parse(row.pushContent || '{}').id
        } catch (e) {
          pushId = null
        }
        const matched = noticeContents.find(item => item.id === pushId)
        if (matched && matched.status === 'WAIT_CONFIRM') {
          // 确认弹窗内容取自本接口的 display 字段（无需再调 loginDisplay）
          this.showChannelFeeNotice = true
          this.$nextTick(() => {
            this.$refs.channelFeePop.init(result.display)
          })
        } else {
          this.$refs.channelFeeRecord.open(result)
        }
        return
      }
      this.activityType = row.msgType
      if (row.msgType === 9 || row.msgType === 10 || row.msgType === 12) {
        this.activeDialogVisible = true
        const { company: isCompany, companyId } = this.userInfo
        const { code, result } = await getActivityDetail({ msgId: row.id, taskId: row.taskId, isCompany, companyId })
        if (code !== 200) return
        this.activeTableData = result?.detailList || []
        this.activeLogData = result?.operateLogList || []
      } else {
        this.$router.push({ path: '/merchant/messageNotice', query: { id: row.taskId } })
        this.$track.clickEvent('消息管理-查看', '1628492898')
      }
    },
    // 告知函确认成功：关闭弹窗并刷新列表
    onChannelFeeConfirmed () {
      this.showChannelFeeNotice = false
      this.initPage()
    },
    // 获取table ||  特殊的请求或数据处理，可以覆写该方法
    async refresh () {
      store.dispatch('infoAll/setInfoNum')
      this.tableLoading = true
      const data = { ...this.searchBar, ...this.pagination, ...this.$_otherParams}
      //对查询条件做一次缓存
      this.downloadParams = { ...this.searchBar,...this.$_otherParams }
      if (this.$_hasSum) {
        this.getSumInfo(data)
      }
      try{
        const { code, result = [], totalRow = 0 } = await this.$_listApi(data)
        if(code !== 200) return
        this.tableData.records = result
        this.tableData.total = parseInt(totalRow)
      }catch(err){
        console.log(err)
      }finally{
        this.tableLoading = false
      }
    },
    // 获取查询条件：交易类型
    async getQueryStatus () {
      try{
        const { code, result = [] } = await getMsgTypeList()
        if(code !== 200) return
        const initObj = { msgType: this.optionsWrapper(result) }
        this.setSearchConfig(initObj)
      }catch(err){
        console.log(err)
      }
    },
    // 全部已读
    async readAllApi () {
      try { 
        const { code } = await readAll()
        if (code !== 200) return
        this.initPage()
        store.dispatch('infoAll/setInfoNum')
      } catch (e) {
        console.log(e)
      }
    },
    gotoOldDetail(){
      this.$router.push({path:'/bill/oldBillDetailList'})
    }
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
.dialog_content {
  height: 500px;
  overflow-y: auto;
  .dialog_row {
    margin-top: 30px;
    .title {
      font-weight: bold;
      margin-bottom: 20px;
    }
    /deep/.el-table {
      margin-top: 20px;
    }
  }
}
</style>
